var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0034 2H17.1034C14.9234 2 13.7734 3.15 13.7734 5.33V7.23C13.7734 9.41 14.9234 10.56 17.1034 10.56H19.0034C21.1834 10.56 22.3334 9.41 22.3334 7.23V5.33C22.3334 3.15 21.1834 2 19.0034 2Z",
    fill: "#FF627D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5735 13.4299H5.6735C3.4835 13.4299 2.3335 14.5799 2.3335 16.7599V18.6599C2.3335 20.8499 3.4835 21.9999 5.6635 21.9999H7.5635C9.7435 21.9999 10.8935 20.8499 10.8935 18.6699V16.7699C10.9035 14.5799 9.7535 13.4299 7.5735 13.4299Z",
    fill: "#FF627D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6235 10.58C8.9928 10.58 10.9135 8.6593 10.9135 6.29C10.9135 3.9207 8.9928 2 6.6235 2C4.25419 2 2.3335 3.9207 2.3335 6.29C2.3335 8.6593 4.25419 10.58 6.6235 10.58Z",
    fill: "#FF627D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0434 21.9999C20.4127 21.9999 22.3334 20.0792 22.3334 17.7099C22.3334 15.3406 20.4127 13.4199 18.0434 13.4199C15.6741 13.4199 13.7534 15.3406 13.7534 17.7099C13.7534 20.0792 15.6741 21.9999 18.0434 21.9999Z",
    fill: "#FF627D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelectedIcon);
export default __webpack_public_path__ + "static/media/dashboard-selected-icon.b826c14a3463b7b06dda34762eb36f8e.svg";
export { ForwardRef as ReactComponent };